<ph-card>
    <ph-stack>
        <ph-toolbar justify="between">
            <span class="check-amount">{{ check.formattedAmount }}</span>
            <span>{{ check.checkNumber }}</span>
        </ph-toolbar>
        <ph-hint>{{ check.amountInWords }}</ph-hint>
        <ph-facts>
            <ph-fact>
                <ph-label>Pay to</ph-label>
                <div>
                    <div>{{ check.payee }}</div>
                    <ng-container *ngIf="displayVendorAddress && check.vendor">
                        <div>{{ check.vendor.name }}</div>
                        <div>{{ check.vendor.address1 }}</div>
                        <div *ngIf="check.vendor.address2">{{ check.vendor.address2 }}</div>
                        <div>{{ check.vendor.city }}, {{ check.vendor.state }} {{ check.vendor.zip }}</div>
                    </ng-container>
                </div>
            </ph-fact>
            <ph-fact>
                <ph-label>Date</ph-label>
                <div *ngIf="check.id; else checkDate">{{ check.checkDate | legfiDate: 'shortDate' }}</div>
                <ng-template #checkDate>
                    <div>{{ check.checkDate }}</div>
                </ng-template>
            </ph-fact>
            <ph-fact>
                <ph-label>Memo</ph-label>
                <div>{{ check.memo ? check.memo : '--' }}</div>
            </ph-fact>
        </ph-facts>
    </ph-stack>
</ph-card>
